module.exports = __webpack_public_path__ + "img/drop-down-black.5d784486.svg";